<template>
  <div class="product card">
    <header>
      <h3 v-html="product.display_name ?? product.name" />
    </header>
    <div class="details">
      <h5>Pricing</h5>

      <div class="pricing-table">
        <div
          v-for="(currency, currencyIndex) in product.prices"
          :key="currencyIndex"
        >
          <div
            v-for="(price, index) in currency"
            :key="index"
          >
            <h4 v-html="price.name !== '' ? price.name : `${currencyIndex} price`" />
            <p>
              <span v-html="`${price.priceString}`" />
              <small v-html="billingPeriodDisplay(price.billing_period)" />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    }
  },
  emits: [
    'edit-product',
  ],
  methods: {
    billingPeriodDisplay(billingPeriod) {
      switch (billingPeriod) {
        case 'MONTH':
          return '/mo';
        case 'YEAR':
          return '/ann';
        default:
          return '';
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .product {
    padding: 2rem;
    box-shadow: none;
    margin: 0;

    header {
      display: flex;

      h3 {
        font-size: 1.5rem;
        font-weight: 700;
        flex-grow: 1;
      }
    }

    .details {
      h4 {
        font-size: 1rem;
        font-weight: 500;
        margin: 0;
      }

      > h5 {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.188rem;
      }

      .pricing-table > div {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.25rem;

      }
    }
  }
</style>
